import React, { Component } from 'react';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import EditSortableMenuItem from './editSortableMenuItem';
import constants from '../../constants';
import { filterCheckInFromMenus } from '../../utilities/utils';

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
};

class SortableMenuItemList extends Component {
    constructor(props) {
        super(props);
        let menuItems = this.props.menuItems?.length > 0 ? this.props.menuItems.sort((a, b) => { return a.displayOrder - b.displayOrder; }) : [];
        this.state = {
            items: filterCheckInFromMenus(menuItems)
        };
        this.onDragEnd = this.onDragEnd.bind(this);
        this.handleMenuItemChange = this.handleMenuItemChange.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (!this.state.items.includes(this.props.menuItems[0])) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({
                items: this.props.menuItems?.length > 0 ? this.props.menuItems.sort((a, b) => {
                    return a.displayOrder - b.displayOrder;
                }) : [],
            });
        } else if (this.props.menuItems?.length !== prevProps.menuItems?.length) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({
                items: this.props.menuItems?.length > 0 ? this.props.menuItems.sort((a, b) => {
                    return a.displayOrder - b.displayOrder;
                }) : [],
            });
        }
    }

    handleMenuItemChange(field, val, menuItem) {
        if (this.props.onSingleMenuItemChange) {
            this.props.onSingleMenuItemChange(field, val, menuItem);
        }
    }

    onDragEnd(result) {
        // dropped outside the list
        if (!result.destination) {
            return;
        }
        const sourceIndex = result.source.index;
        const destIndex = result.destination.index;
        if (result.type === 'droppableItem') {
            // eslint-disable-next-line react/no-access-state-in-setstate
            const items = reorder(this.state.items, sourceIndex, destIndex);

            this.setState({
                items,
            });
            this.props.onMenuItemsDisplayOrderChange(items);
        }
    }

    render() {
        let dragClass = '';
        if (this.props.isDragging) {
            dragClass = 'sortable-drag';
        }

        return (
            <div>
                {' '}
                <DragDropContext onDragEnd={this.onDragEnd}>
                    <Droppable droppableId="droppable" type="droppableItem">
                        {(provided) => {
                            return (
                                <div
                                    data-qa="menu-card-holder"
                                    ref={provided.innerRef}
                                >
                                    {this.state.items.map((menuItem, index) => {
                                        return (
                                            <EditSortableMenuItem
                                                userSelectedIcons={this.props.userSelectedIcons}
                                                onChange={this.handleMenuItemChange}
                                                menuItem={menuItem}
                                                menuItemsMetadata={constants.MenuSubType}
                                                className={dragClass}
                                                modules={this.props.modules}
                                                index={index}
                                                key={menuItem.id}
                                            />

                                        );
                                    })}
                                    {provided.placeholder}
                                </div>
                            );
                        }}
                    </Droppable>
                </DragDropContext>

            </div>
        );
    }
}

export default SortableMenuItemList;
